// Пакет с данными нарисованных треков
var tracks = [];
// Пакет необработынных данных, пришедших с сервера.
// Включает в себя пакеты данных для рисования треков.
var lastTracks = [];
// zoomedInterval - Интервал в зависимости от зума карты, 
// представляет собой объект, где key - zoom, а value - значение интервала между маркерами в км.
var zoomedInterval = {
  6: 15,
  7: 10,
  8: 6,
  9: 4,
  10: 2.6,
  11: 1.8,
  12: 1,
  13: 0.7,
  14: 0.5,
  15: 0.25,
  16: 0.08,
  17: 0.04,
  18: 0.02
}

var initTracksOnMapShowing = function (mymap, tracksUrl, keepOld) {

  function clear() {
    tracks = [];
    lastTracks = [];
    mymap.eachLayer(function (layer) {
      if (layer.options && (layer.options.isTrack || layer.options.isDirection)) {
        mymap.removeLayer(layer);
      }
    });
  }

  function drawTrack(trackPoints, obj) {
    var track = { polyline: null };
    if (trackPoints.length > 1) {
      var points = [];
      var popup = obj ? '<div>' + obj.vehicle + ' </div> <br />' : '<br />';
      // Добавляем html спиннера загрузки
      popup+='<div class="modal-spinner"><div class="sk-spinner sk-spinner-wave orange"> <div class="sk-rect1"> </div> <div class="sk-rect2"> </div> <div class="sk-rect3"> </div> <div class="sk-rect4"> </div> <div class="sk-rect5"> </div> </div></div>';
      track.polyline = new L.layerGroup();

      var lastPoint = [];
      for (var i = 0; i < trackPoints.length; i++) {
        var point = L.latLng(trackPoints[i][0], trackPoints[i][1]);
        points.push(point);

        if ($('#OnDirection').prop('checked')) {
          var drawingPoint = _drawDirection(track.polyline, trackPoints, i, popup, lastPoint, zoomedInterval[mymap.getZoom()]);
          if (drawingPoint && drawingPoint.length > 0) {
            lastPoint = drawingPoint;
          }
        }
      }

      track.polyline.addLayer(new L.Polyline(points, {
        title: popup,
        color: 'blue',
        weight: 5,
        opacity: 0.5,
        smoothFactor: 1,
        isTrack: true,
        vehicleId: obj.id
      }).bindPopup(popup));

      track.polyline.addTo(mymap);
    }
    return track;
  }

    function reloadTrack(keepOld) {
        if (!keepOld)
            clear();
    $.each(tracksUrl, function (idx, trackUrl) {
      $.ajax({
        url: trackUrl.url,
        type: 'POST',
        dataType: 'json',
        data: trackUrl.data
      }).success(function (result) {
          if (result && result[0].Datas.length > 0) {
              if (keepOld) {
                  var vehicleIds = result.map(function(r) {
                      return r.Vehicle ? r.Vehicle.Id : null;
                  }).filter(function(id) {
                      return id !== null;
                  });
                  tracks = tracks.filter(function(t) {
                      var keep = vehicleIds.indexOf(t.vehicleId) === -1;
                      if (!keep)
                          mymap.removeLayer(t.polyline);
                      return keep;
                  });
              }
          lastTracks.push(result);
          result.forEach(function (obj, idx) {
              var track = drawTrack(obj.Datas, { vehicleId: obj.Vehicle ? obj.Vehicle.Id : null, vehicle: obj.Vehicle ? obj.Vehicle.Name : '', timeInterval: obj.Interval });
              tracks.push({ track: track, url: trackUrl, vehicleId: obj.Vehicle ? obj.Vehicle.Id : null });
          });
        }
      }).error(function (xhr, status) {
        console.error(status);
      });
    });
  }

    reloadTrack(keepOld);

  return tracks;
}

var initVehicleTrackMap = function (editable) {
    var initLat = AppConfig.defaultMapCenter[0];
    var initLng = AppConfig.defaultMapCenter[1];

  L.Icon.Default.imagePath = AppConfig.imagePath;
  var grayscale = L.tileLayer(MapSettings.urlFormat, { attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' });

  var mymap = L.map('track-map', {
    center: [initLat, initLng],
    zoom: AppConfig.defaultMapZoom,
    maxBounds: L.latLngBounds(AppConfig.defaultMapBounds[0], AppConfig.defaultMapBounds[1]),
    minZoom: AppConfig.defaultMapMinZoom,
    zoomReverse: true,
      layers: [grayscale],
    editable: editable || false
    });

  getPointTrack(mymap);

  $('#OnDirection').on('change', function () {
    drawDirections(mymap, $(this).prop('checked'));
  });

  mymap.on('zoomend', function(e) {
    if ($('#OnDirection').prop('checked')) {
      drawDirections(mymap, false);
      drawDirections(mymap, $('#OnDirection').prop('checked'));
    }
  });

  return mymap;
}

// Получаем инфо точки трека
// Параметры:
// map - Leaflet карта, на которой построен трек
var getPointTrack = function (map) {

  // Функ-я сравнения координат типа Объект {lat, lng}
  function _compareLatLngs(left, right) {
    return left.lat.toFixed(5) === right.lat.toFixed(5) && left.lng.toFixed(5) === right.lng.toFixed(5);
  }

  // Функ-я получения инфо о точке трека
  // Параметры:
  // urlObj - объект {url - адрес для формирования трека, data - период формирования трека}
  // pointIndex - Индекс выбранной точки из трека
  // $container - контейнер попап окна Leaflet
  function getPointDatas(urlObj, pointIndex, $container) {
    var infoDefault = '<div style="width: 160px;"> Время: "Не известно" <br /> Скорость: "Не известно" </div>';
    if (pointIndex) {
      $.ajax({
        url: urlObj.url + '/' + pointIndex,
        contentType: 'application/json; charset=utf-8',
        type: 'GET',
        dataType: 'json',
        data: urlObj.data
      }).done(function (result) {
        var data = result ?
          '<div style="width: 160px;"> Время: {OnDateString}  <br />  Скорость: {Speed} км/ч </div>'.format(result) :
          infoDefault;
        // Актуализуем инфо
        _updatePopup($container, data);
      }).fail(() => {
        $container.html($container.html() + infoDefault);
        $container.removeClass('busy'); // Убираем спиннер загрузки
      });
    }
  }

  // Обновляем данные в попап-балуне
  // $container - контейнер попап балуна, класс которого '.leaflet-popup-content'
  // data - html с инфо о скорости и времени
  function _updatePopup($container, data) {
    $container.html($container.html() + data); // обновляем html
    var beforeWidth = $container.width(); // Узнаем размер попап-балуна до обновления его ширины
    $container.width('80%'); // обновляем ширину попап-балуна
    var afterWidth = $container.width(); // Узнаем размер попап-балуна после обновления его ширины
    var leftCoefficient = (afterWidth - beforeWidth) / 2; // Вычисяем коэффициент сдвига попап-балуна
    var left = $container.closest('.leaflet-popup').css('left'); // Узнаем текущее положение от левого края (строка)
    var trueLeft = Number(left.replace('px', '')) - leftCoefficient; // Изменяем величину положения попап-балуна от левого края
    $container.closest('.leaflet-popup').attr('style', $container.closest('.leaflet-popup').attr('style').replace(left, trueLeft + 'px')); // Изменяем положение попап-балуна от левого края
    $container.removeClass('busy'); // Убираем спиннер загрузки
  }

  map
    .on('popupopen', function (e) {
      var $popupContent = $('.leaflet-popup-content', e.popup._container);
      $popupContent.addClass('busy'); // Добавляем спиннер загрузки
      tracks.forEach(function (data, idx) {
        $.each(data.track.polyline._layers, function (idx, layer) {
          // Если в опциях слоя есть маркер, что это трек,
          // и попап окно слоя аналогично открытому попап окну, или у открытого окна в опциях есть маркер, что это направление,
          // то ищем точку в этом слое, которая равна, или близко расположена к координатам точки клика по треку
          if (layer.options && layer.options.isTrack && (layer._popup === e.popup || e.popup.options.isDirection)) {
            var pointIndex = 0;
            var point = layer._latlngs ?
              $.grep(layer._latlngs, function (n, i) { if (_compareLatLngs(n, e.popup._latlng)) { pointIndex = i; } return _compareLatLngs(n, e.popup._latlng); }) :
              [];
            // Если true, значит клик был не по маркеру направления => pointIndex не найден, необходимо искать точку на polilyne
            if (point.length === 0) {
              pointIndex = MapHelper.findPosition(e.popup._latlng, layer._latlngs, MapHelper.getZoom(map).coefficient).index;
            }
            getPointDatas(data.url, pointIndex, $popupContent);

            return;
          }
        });
      });
    });
}

// Отрисовка стрелок направлений
// Параметры:
// map - инициализированная карта Leaflet
// isChecked - если true, добавляет стрелки на карту, иначе стирает
var drawDirections = function (map, isChecked) {
  if (isChecked) {
    map.eachLayer(function (layer) {
      if (layer.options && layer.options.isTrack) {
        // lastTracks - данные, которые были получены в ходе построения треков
        if (lastTracks) {
          lastTracks.forEach(function (tracks, idx) {
            // tracks - пакет, включающий в себя массив инфо о ТС и трек ТС
            tracks.forEach(function (trackData, idx) {
              var popup;
              if (trackData.Vehicle) {
                popup = trackData.Vehicle.Name ? '<div>' + trackData.Vehicle.Name + ' </div><br />' : '<br />';
                // Добавляем html спиннера загрузки
                popup += '<div class="modal-spinner"><div class="sk-spinner sk-spinner-wave orange"> <div class="sk-rect1"> </div> <div class="sk-rect2"> </div> <div class="sk-rect3"> </div> <div class="sk-rect4"> </div> <div class="sk-rect5"> </div> </div></div>';
              }
              var track = trackData.Datas;
              var lastPoint = [];
              for (var i = 0; i < track.length; i++) {
                var drawingPoint = _drawDirection(map, track, i, popup, lastPoint, zoomedInterval[map.getZoom()]);
                if (drawingPoint && drawingPoint.length > 0) {
                  lastPoint = drawingPoint;
                }
              }
            });
          });
        }
      }
    });
  } else {
    map.eachLayer(function (layer) {
      // Проверка на принадлежность слоя к треку
      if (layer.options && layer.options.isDirection) {
        map.removeLayer(layer);
      }
    });
  }
}

// Функ-я проверки наличия заданного интервала между двумя географическими точками
// Параметры:
// left - первая точка, представляет собой массив [lat, lng]
// right - вторая точка, представляет собой массив [lat, lng]
// interval - заданное в километрах расстояние между двумя точками
function _hasInterval(left, right, interval) {
  var distance = left && left.length > 0 && right ? L.latLng(left[0], left[1]).distanceTo(right) : 0;

  return interval && distance && interval * 1000 <= distance;
}

// Отрисовка направлений для трека
// Параметры:
// layerGroup - группа, в которую будут добавлены маркеры направлений
// track - пакет данных, включающий в себя точку трека и направление движения
// idx - индекс пакета
// popup (nullable) - информация о добавляемом маркере направления (сбиндится в попап окно Leaflet)
// lastPoint (nullable) - Предыдущая точка с маркером направления
// interval (nullable) - Интервал (км), с учетом зума карты, через который будут рисоваться маркеры направлений
function _drawDirection(layerGroup, track, idx, popup, lastPoint, interval, vehicleId) {
  // Парсинг данных пакета
  // Координаты для маркера выбираются, если точка первая или последняя в списке, 
  // или расстояние между маркером и текущей точкой не меньше чем заданный интервал
  var point = idx === 0 ?
    [track[0][0], track[0][1]] :
    idx === track.length - 1 ?
    [track[track.length - 1][0], track[track.length - 1][1]] :
    _hasInterval(lastPoint, [track[idx][0], track[idx][1]], interval) ?
    [track[idx][0], track[idx][1]] :
    [];
  if (!point || point.length === 0) {
    return point;
  }

  // Угол поворота маркера (направление движения ТС)
  var direction = track[idx][2];
  // Опции добавляемого маркера - Объект { icon - иконка маркера направления, isDirection - опция, определяющая отношение маркера к треку }
    var options = {
        icon: new L.divIcon({
            className: "directionIcon",
            iconSize: new L.Point(21, 12),
            iconAnchor: new L.Point(11, 6),
            html: "<div style = 'font-size: 20px; -webkit-transform: rotate(" +
                direction +
                "deg); -ms-transform: rotate(" +
                direction +
                "deg); -moz-transform: rotate(" +
                direction +
                "deg); -o-transform: rotate(" +
                direction +
                "deg);'>&#10152</div>"
        }),
        isDirection: true,
        vehicleId: vehicleId
    };
  // Добавление маркера в группу объектов карты
  var markerDirection;
  if (popup && popup.length > 0) {
    markerDirection = new L.marker(point, options).bindPopup(popup, { isDirection: true });
  } else {
    markerDirection = new L.marker(point, options);
  }
  layerGroup.addLayer(markerDirection);

  return point;
}
